// extracted by mini-css-extract-plugin
module.exports = {"icon":"RefundHistoryAcessGrantedState_icon__2J4UW"};